/**
 * Canonical allow-list for tenant Audio Asset upload (TASK-00078).
 * Keep in sync with backend/app/saas/audio_upload_allowlist.py
 */

export const AUDIO_UPLOAD_EXTENSIONS = ['.wav', '.mp3', '.m4a', '.aac', '.ogg', '.flac'] as const

export const AUDIO_UPLOAD_MIME_TYPES = [
  'audio/wav',
  'audio/x-wav',
  'audio/wave',
  'audio/mpeg',
  'audio/mp3',
  'audio/m4a',
  'audio/x-m4a',
  'audio/aac',
  'audio/ogg',
  'audio/flac',
  'audio/x-flac',
] as const

export const AUDIO_UPLOAD_BLOCKED_EXTENSIONS = ['.mp4'] as const

export const AUDIO_UPLOAD_BLOCKED_MIME_TYPES = ['audio/mp4', 'application/mp4', 'video/mp4'] as const

const MIME_SET = new Set<string>(AUDIO_UPLOAD_MIME_TYPES)
const EXT_SET = new Set<string>(AUDIO_UPLOAD_EXTENSIONS)
const BLOCKED_EXT_SET = new Set<string>(AUDIO_UPLOAD_BLOCKED_EXTENSIONS)
const BLOCKED_MIME_SET = new Set<string>(AUDIO_UPLOAD_BLOCKED_MIME_TYPES)

export function buildAudioUploadFileInputAccept(): string {
  return [...AUDIO_UPLOAD_MIME_TYPES, ...AUDIO_UPLOAD_EXTENSIONS].join(',')
}

function extensionFromFilename(filename: string): string | null {
  const lower = filename.toLowerCase()
  const dot = lower.lastIndexOf('.')
  if (dot < 0) return null
  return lower.slice(dot)
}

function normalizeMime(mime: string): string {
  return (mime || '').split(';', 1)[0].trim().toLowerCase()
}

/** Frontend validation — extension + MIME, rejects MP4/video containers. */
export function isAllowedAudioAssetUploadFile(file: File): boolean {
  const ext = extensionFromFilename(file.name)
  const mime = normalizeMime(file.type)

  if (!ext || BLOCKED_EXT_SET.has(ext)) return false
  if (!EXT_SET.has(ext)) return false
  if (mime.startsWith('video/') || BLOCKED_MIME_SET.has(mime)) return false
  if (mime && !MIME_SET.has(mime)) return false
  return true
}
